import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

var SvgSend = function SvgSend(_a) {
  var title = _a.title,
    desc = _a.desc,
    titleId = _a.titleId,
    descId = _a.descId,
    props = __rest(_a, ["title", "desc", "titleId", "descId"]);
  var ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? " ".concat(descId) : '';
  props['aria-labelledby'] = ariaLabelledBy;
  return jsxs("svg", __assign({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !!ariaLabelledBy
  }, props, {
    children: [!!title && jsx("title", __assign({
      id: titleId
    }, {
      children: title
    }), void 0), !!desc && jsx("desc", __assign({
      id: descId
    }, {
      children: desc
    }), void 0), jsx("g", __assign({
      clipPath: "url(#clip0_222_208)"
    }, {
      children: jsx("path", {
        d: "M14.4042 25.0231L21.6271 6.95671L3.56071 14.1796L7.77158 18.4026L18.0126 10.5712L10.1812 20.8122L14.4042 25.0231Z",
        fill: "currentColor"
      }, void 0)
    }), void 0), jsx("defs", {
      children: jsx("clipPath", __assign({
        id: "clip0_222_208"
      }, {
        children: jsx("rect", {
          width: 28,
          height: 28,
          fill: "white"
        }, void 0)
      }), void 0)
    }, void 0)]
  }), void 0);
};

export { SvgSend as default };
